var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "div",
        { staticClass: "subTitle" },
        [
          _c(
            "el-link",
            {
              attrs: {
                icon: "el-icon-arrow-left",
                underline: false,
                href: "#/businessPartnerManagement"
              }
            },
            [_vm._v("Business Partner Management")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "title",
          attrs: { content: "edit", placement: "bottom" }
        },
        [_vm._v("\n    Edit Business Partner Account\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detailContent" },
        [
          _c("div", { staticClass: "requireRmarks" }, [
            _vm._v("*Required Fields")
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "formAccount",
              attrs: {
                "label-width": "50%",
                "label-position": "left",
                model: _vm.formAccount,
                rules: _vm.formAccountRules
              }
            },
            [
              _c("el-row", [_c("h4", [_vm._v("Profile")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Vendor ID/Employee ID",
                            prop: "clientID"
                          }
                        },
                        [_c("p", [_vm._v(_vm._s(_vm.formAccount.clientID))])]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formAccount.userStatus != "OPENED"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "Username" } }, [
                            _c("p", [_vm._v(_vm._s(_vm.formAccount.userName))])
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _vm.formAccount.sfRecordType !== "CP"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.formAccount.isDummyUser
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Last Name",
                                    prop: "lastName",
                                    error: _vm.formAccount.lastName
                                      ? ""
                                      : "Last Name cannot be empty"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { maxlength: "50" },
                                    model: {
                                      value: _vm.formAccount.lastName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formAccount,
                                          "lastName",
                                          $$v
                                        )
                                      },
                                      expression: "formAccount.lastName"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "el-form-item",
                                { attrs: { label: "Last Name" } },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formAccount.lastName
                                          ? _vm.formAccount.lastName
                                          : "-"
                                      )
                                    )
                                  ])
                                ]
                              )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formAccount.sfRecordType !== "CP"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "First Name", prop: "firstName" }
                            },
                            [
                              _vm.formAccount.isDummyUser
                                ? _c("el-input", {
                                    attrs: { maxlength: "50" },
                                    model: {
                                      value: _vm.formAccount.firstName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formAccount,
                                          "firstName",
                                          $$v
                                        )
                                      },
                                      expression: "formAccount.firstName"
                                    }
                                  })
                                : _c("p", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.formAccount.firstName
                                            ? _vm.formAccount.firstName
                                            : "-"
                                        ) +
                                        "\n            "
                                    )
                                  ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("General Information")])]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "border-box" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      !_vm.formAccount.isDummyUser
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Mobile Phone",
                                    prop: "salesforcePhone"
                                  }
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.formAccount.cellularphone
                                            ? _vm.formAccount.cellularphone
                                            : "-"
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.formAccount.isDummyUser
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Buiness Phone",
                                    prop: "buinessPhone"
                                  }
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.formAccount.phone
                                            ? _vm.formAccount.phone
                                            : "-"
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      !_vm.formAccount.isDummyUser
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Salesforce Email address",
                                    prop: "salesforceEmail"
                                  }
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.formAccount.salesforceEmail
                                            ? _vm.formAccount.salesforceEmail
                                            : "-"
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Preferred Language",
                                prop: "preferredLanguage"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formAccount.salesforceLanguage
                                        ? _vm.formAccount.salesforceLanguage
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Setting")])]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "border-boxshadow" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Market updates",
                                prop: "Market updates"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formAccount.marketUpdates
                                      ? _vm.formAccount.marketUpdates
                                      : "-"
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "Corporate", prop: "Corporate" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formAccount.corporate
                                      ? _vm.formAccount.corporate
                                      : "-"
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Sales Information")])]),
              _vm._v(" "),
              _c("div", { staticClass: "border-boxshadow" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 50 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Sales Office" } },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$commonjs.salesOfficeMap(
                                        _vm.formAccount.salesOffice
                                      )
                                    )
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("el-form-item", { attrs: { label: "Region" } }, [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$commonjs.regionMap(
                                      _vm.formAccount.region
                                    )
                                  )
                                )
                              ])
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Sales Representative Name" } },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.formAccount.representativeName
                                          ? _vm.formAccount.representativeName
                                          : "-"
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Record Type" } },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.safeGetNameField(
                                          _vm.formAccount.salesforceRecordType
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Salesforce Region" } },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.safeGetNameField(
                                          _vm.formAccount.salesforceRegion
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 50 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Referral Company / Individual Planner"
                                }
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.formAccount
                                          .salseforceServicingChannelName
                                          ? _vm.formAccount
                                              .salseforceServicingChannelName
                                          : "-"
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "Referral Planner /  Broker" }
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.formAccount
                                          .salseforceServicingFinancialPlanner
                                          ? _vm.formAccount
                                              .salseforceServicingFinancialPlanner
                                          : "-"
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 50 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Sub-Referral Company" } },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.formAccount.salseforceReferredByIfa
                                          ? _vm.formAccount
                                              .salseforceReferredByIfa
                                          : "-"
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Sub-Referral Planner" } },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.formAccount
                                          .salseforceReferredByPlanner
                                          ? _vm.formAccount
                                              .salseforceReferredByPlanner
                                          : "-"
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 50 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Referred By (Client LV)" } },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.formAccount
                                          .salseforceReferredByClientLv
                                          ? _vm.formAccount
                                              .salseforceReferredByClientLv
                                          : "-"
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Servicing Channel Type" } },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.formAccount
                                          .salseforceServicingChannelType
                                          ? _vm.formAccount
                                              .salseforceServicingChannelType
                                          : "-"
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Client")])]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "border-boxshadow" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Client List" } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "100%" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleClientList(false)
                                    }
                                  }
                                },
                                [_vm._v("View")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Status")])]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "border-boxshadow" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Last Success Login",
                                prop: "lastLogin"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formAccount.lastLogin
                                        ? _vm.$commonjs.paramFormatDate(
                                            _vm.formAccount.lastLogin
                                          )
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Last Password Update",
                                prop: "lastPwd"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formAccount.lastPwd
                                        ? _vm.$commonjs.paramFormatDate(
                                            _vm.formAccount.lastPwd
                                          )
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Account Status",
                                prop: "userStatus"
                              }
                            },
                            [
                              _c(
                                "p",
                                {
                                  style:
                                    _vm.formAccount.userStatus == "ACTIVATED"
                                      ? "color:rgb(0,127,80)"
                                      : _vm.formAccount.userStatus == "OPENED"
                                      ? "color:rgb(85,130,160)"
                                      : "color:rgb(255,0,0)"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$commonjs.userStatusMap(
                                          _vm.formAccount.userStatus
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Activation Date & Time",
                                prop: "activationAt"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formAccount.activationAt
                                        ? _vm.$commonjs.paramFormatDate(
                                            _vm.formAccount.activationAt
                                          )
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Remarks",
                                prop: "userTypeRemarks"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { maxlength: "100" },
                                model: {
                                  value: _vm.formAccount.userTypeRemarks,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formAccount,
                                      "userTypeRemarks",
                                      $$v
                                    )
                                  },
                                  expression: "formAccount.userTypeRemarks"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: { padding: "25px 0" },
          attrs: { type: "flex", justify: "end", gutter: 20 }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _vm.showSave
                ? _c(
                    "el-button",
                    {
                      staticClass: "reset",
                      staticStyle: { width: "100%" },
                      on: { click: _vm.handleCancel }
                    },
                    [_vm._v("Cancel")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.formAccount.userStatus != "OPENED"
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _vm.showSave
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSave }
                        },
                        [_vm._v("Save")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Client List",
            visible: _vm.clientListPopup,
            width: "90%",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.clientListPopup = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "searchClientForm",
              staticClass: "demo-form-inline",
              staticStyle: { "text-align": "left" },
              attrs: {
                "label-position": "top",
                model: _vm.searchClientForm,
                inline: true
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      placeholder: "Client ID / Name",
                      maxlength: "100"
                    },
                    model: {
                      value: _vm.searchClientForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.searchClientForm, "name", $$v)
                      },
                      expression: "searchClientForm.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { staticClass: "search", on: { click: _vm.getClientList } },
                    [_vm._v("Search")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "reset",
                      on: { click: _vm.resetSearchForm }
                    },
                    [_vm._v("Reset")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right" },
                  on: { click: _vm.handleExport }
                },
                [_vm._v("Export")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    float: "right",
                    "margin-right": "30px",
                    "margin-top": "10px"
                  }
                },
                [
                  _c(
                    "el-dropdown",
                    { ref: "filter", attrs: { trigger: "click" } },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "el-dropdown-link sortbox",
                          staticStyle: { cursor: "pointer" }
                        },
                        [
                          _c("em", { staticClass: "filter" }),
                          _vm._v("\n            Filter\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "formFilter",
                              staticStyle: {
                                width: "300px",
                                padding: "14px 24px"
                              },
                              attrs: { model: _vm.filterFrom }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-bottom": "12px" },
                                  attrs: { label: "Region" }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        "popper-append-to-body": false,
                                        multiple: "",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.filterFrom.region,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filterFrom,
                                            "region",
                                            $$v
                                          )
                                        },
                                        expression: "filterFrom.region"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-option",
                                        { attrs: { value: "All" } },
                                        [_vm._v("All")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.RegionList, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.name,
                                            value: item.code
                                          }
                                        })
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-bottom": "12px" },
                                  attrs: { label: "Language" }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        "popper-append-to-body": false,
                                        multiple: "",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.filterFrom.language,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filterFrom,
                                            "language",
                                            $$v
                                          )
                                        },
                                        expression: "filterFrom.language"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-option",
                                        { attrs: { value: "All" } },
                                        [_vm._v("All")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.languageList, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.name,
                                            value: item.code
                                          }
                                        })
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-bottom": "12px" },
                                  attrs: { label: "Project" }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        "popper-append-to-body": false,
                                        filterable: "",
                                        multiple: "",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.filterFrom.project,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filterFrom,
                                            "project",
                                            $$v
                                          )
                                        },
                                        expression: "filterFrom.project"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-option",
                                        { attrs: { value: "All" } },
                                        [_vm._v("All")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.ProductsList, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.name,
                                            value: item.code
                                          }
                                        })
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-bottom": "12px" },
                                  attrs: { label: "Master Plan" }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        "popper-append-to-body": false,
                                        filterable: "",
                                        multiple: "",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.filterFrom.masterPlan,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filterFrom,
                                            "masterPlan",
                                            $$v
                                          )
                                        },
                                        expression: "filterFrom.masterPlan"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-option",
                                        { attrs: { value: "All" } },
                                        [_vm._v("All")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.masterPlanIDList, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.name,
                                            value: item.code
                                          }
                                        })
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "filterButton" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        "margin-right": "15px",
                                        "margin-bottom": "0"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "reset",
                                          on: {
                                            click: function($event) {
                                              _vm.$refs.filter.hide()
                                              _vm.resetForm()
                                            }
                                          }
                                        },
                                        [_vm._v("Reset")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { staticStyle: { "margin-bottom": "0" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "search",
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function() {
                                              _vm.$refs.filter.hide()
                                              _vm.getClientList()
                                            }
                                          }
                                        },
                                        [_vm._v("Apply")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.clientList, "max-height": "490px" } },
            [
              _c("el-table-column", {
                attrs: { prop: "clientID", label: "Client ID", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(scope.row.clientID ? scope.row.clientID : "-")
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Name" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.lastName +
                                ", " +
                                scope.row.firstName +
                                " " +
                                scope.row.middleName
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Sales Office", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.$commonjs.salesOfficeMap(scope.row.salesOffice)
                          )
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Region", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm.$commonjs.regionMap(scope.row.region))
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "representative",
                  label: "Sales Representative Name",
                  formatter: _vm.$commonjs.tableEmptyField
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "salseforceServicingChannelType",
                  label: "Servicing Channel Type",
                  formatter: _vm.$commonjs.tableEmptyField
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "salseforceServicingChannelName",
                  label: "Referral Company / Individual Planner",
                  formatter: _vm.$commonjs.tableEmptyField
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "salseforceServicingFinancialPlanner",
                  label: "Referral Planner / Broker",
                  formatter: _vm.$commonjs.tableEmptyField
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "salseforceReferredByIfa",
                  label: "Sub-Referral Company",
                  formatter: _vm.$commonjs.tableEmptyField
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "salseforceReferredByPlanner",
                  label: "Sub-Referral Planner",
                  formatter: _vm.$commonjs.tableEmptyField
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "salseforceReferredByClientLv",
                  label: "Referred by (Client Lv)",
                  formatter: _vm.$commonjs.tableEmptyField
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "language",
                  label: "Language",
                  formatter: _vm.$commonjs.tableEmptyField
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Master Plan" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.masterPlanNames.length < 6
                          ? _c(
                              "div",
                              _vm._l(scope.row.masterPlanNames, function(item) {
                                return _c("span", { key: item.id }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item) +
                                      ",\n            "
                                  )
                                ])
                              }),
                              0
                            )
                          : _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.masterView,
                                        expression: "!masterView"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.masterPlanNames[0]) +
                                        ",\n              " +
                                        _vm._s(scope.row.masterPlanNames[1]) +
                                        ",\n              " +
                                        _vm._s(scope.row.masterPlanNames[2]) +
                                        ",\n              " +
                                        _vm._s(scope.row.masterPlanNames[3]) +
                                        ",\n              " +
                                        _vm._s(scope.row.masterPlanNames[4]) +
                                        ",\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.masterView,
                                        expression: "masterView"
                                      }
                                    ]
                                  },
                                  _vm._l(scope.row.masterPlanNames, function(
                                    item
                                  ) {
                                    return _c("span", { key: item.id }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(item) +
                                          ",\n              "
                                      )
                                    ])
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.masterView
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "btntext",
                                        attrs: {
                                          slot: "reference",
                                          type: "text"
                                        },
                                        on: { click: _vm.less },
                                        slot: "reference"
                                      },
                                      [_vm._v("View Less")]
                                    )
                                  : _c(
                                      "el-button",
                                      {
                                        staticClass: "btntext",
                                        attrs: {
                                          slot: "reference",
                                          type: "text"
                                        },
                                        on: { click: _vm.more },
                                        slot: "reference"
                                      },
                                      [_vm._v("View More")]
                                    )
                              ],
                              1
                            )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "projects", label: "Project" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.projects.length < 6
                          ? _c(
                              "div",
                              _vm._l(scope.row.projects, function(item) {
                                return _c("span", { key: item.id }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item) +
                                      ",\n            "
                                  )
                                ])
                              }),
                              0
                            )
                          : _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.projectView,
                                        expression: "!projectView"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.projects[0]) +
                                        ", " +
                                        _vm._s(scope.row.projects[1]) +
                                        ",\n              " +
                                        _vm._s(scope.row.projects[2]) +
                                        ", " +
                                        _vm._s(scope.row.projects[3]) +
                                        ",\n              " +
                                        _vm._s(scope.row.projects[4]) +
                                        ",\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.projectView,
                                        expression: "projectView"
                                      }
                                    ]
                                  },
                                  _vm._l(scope.row.projects, function(item) {
                                    return _c("span", { key: item.id }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(item) +
                                          ",\n              "
                                      )
                                    ])
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.projectView
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "btntext",
                                        attrs: {
                                          slot: "reference",
                                          type: "text"
                                        },
                                        on: { click: _vm.projectshutView },
                                        slot: "reference"
                                      },
                                      [_vm._v("View Less")]
                                    )
                                  : _c(
                                      "el-button",
                                      {
                                        staticClass: "btntext",
                                        attrs: {
                                          slot: "reference",
                                          type: "text"
                                        },
                                        on: { click: _vm.projectshowView },
                                        slot: "reference"
                                      },
                                      [_vm._v("View More")]
                                    )
                              ],
                              1
                            )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Status", width: "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: "userstatus-" + scope.row.userStatus },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$commonjs.userStatusMap(
                                    scope.row.userStatus
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Operation", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "Edit",
                              placement: "top"
                            }
                          },
                          [
                            _c("em", {
                              staticClass: "edit",
                              on: {
                                click: function($event) {
                                  return _vm.handleEditClient(scope.row)
                                }
                              }
                            })
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("app-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [5, 10, 20, 50],
              total: _vm.total,
              "page-size": _vm.currentSize
            },
            on: {
              "size-change": function(v) {
                _vm.currentSize = v
                _vm.currentPage = 1
                _vm.getClientList()
              },
              "current-change": function(v) {
                _vm.currentPage = v
                _vm.getClientList()
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-052e6d83", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-052e6d83","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bizUser/EditBizUser.vue
// module id = null
// module chunks = 